import Header from "./components/Header";
import Series from "./components/Series";
import React, { useState } from 'react'

function App() {
  const [serie, setSerie] = useState('spartacus')
  return (
      <div className="App">
        <Header setSerie={setSerie}/>
            <Series serie={serie}/>
      </div>
  );
}

export default App;
